import { useMemo } from 'react';
import { useSurveySelectors } from 'redux/slices/legacySurveySlice';
import { Information } from '../dialog-forms/components/InformationView';
import { InformationView } from '@act/storybook';

interface SurveySummaryProps {
  surveyResponseId: string;
}

const SurveySummary = ({ surveyResponseId }: SurveySummaryProps) => {
  const surveyResponse =
    useSurveySelectors.useSelectSurveyResponseById(surveyResponseId);
  const information = useMemo(() => {
    const information: Information[] = [];
    surveyResponse?.sections.forEach(section =>
      section.questions.forEach(question => {
        if (question.inputType === 'info') return;
        let value: string = `Unrecognized question type, ${question.inputType}`;
        if (question.inputType === 'radio') {
          const selectedOption = question.options?.find(o => o.isSelected);
          value = selectedOption?.text;
        } else if (question.inputType === 'date') {
          value = question.answer?.date || '';
        }
        if (!value) {
          return;
        }
        information.push({
          label: question.text,
          value: value,
        });
      })
    );
    return information;
  }, [surveyResponse]);
  return <InformationView information={information} title="Survey results:" />;
};

export default SurveySummary;
